import { Injectable } from "@angular/core";
import { getBezierPath} from "../utils/bezier-edge";
import { Vector2d } from "konva/lib/types";
import { Path } from "konva/lib/shapes/Path";
import { ARROW_POINTER_RADIUS, ARROW_STROKE_WIDTH_Base, CONTRACT_POINTER_HEIGHT, CONTRACT_POINTER_WIDTH } from "../models/graph-kn.cm.arrows-model-const";
import { IEdgeDrawObjects, IEdgePointersData, IXYEdgeData, IXYNodeShallowData } from "../models/xyflow.models";
import { getSmoothStepPath } from "../utils/smoothstep-edge";
import { getStraightPath } from "../utils/straight-edge";
import { getNodeConnectPoint } from "../utils/xy.general";
import Konva from "konva";
import { Circle } from "konva/lib/shapes/Circle";
import { Rect } from "konva/lib/shapes/Rect";
import { EEdgyType, EdgePointerType, Position } from "../models/graph-kn.model-enums";
import { Arrow } from "konva/lib/shapes/Arrow";
import { IConnectorsEdges } from "../models/graph-kn.model-interfaces";
import { ARROW_COLOR_Base } from "../styles/graph-colors";
export interface IXYNode extends Vector2d {
  id:string,
  width:number,
  height:number
}
@Injectable ({
  providedIn:'root'
})
export class XYEdgeService {
  prepareXYEdge(
    source:IXYNode,target:IXYNode, 
    id:string,
    edgeType:EEdgyType = EEdgyType.Bezier,
    edgePointerType?:EdgePointerType,
    points:Vector2d[] = [],
    connector?:IConnectorsEdges
  ):IEdgeDrawObjects {

   //edgeType = ConnectionLineType.SmoothStep

    let newEdgeGroup:IEdgeDrawObjects= {}
    let fromNode:IXYNodeShallowData = {
      x:source.x,
      y:source.y,
      widht:source.width,
      height:source.height,
    }
    let toNode:IXYNodeShallowData = {
      x:target.x,
      y:target.y,
      widht:target.width,
      height:target.height,
    }
    let edgePointData:IEdgePointersData = {
      pointFrom:{x:fromNode.x + (connector?.fromRelativePos?.x||0),y:fromNode.y + (connector?.fromRelativePos?.y||0)},
      pointFromPosition:connector?.fromEdgePos||Position.Right,
      pointTo: {x:toNode.x + (connector?.toRelativePos?.x||0),y:toNode.y + (connector?.toRelativePos?.y||0)},
      pointToPosition:connector?.toEdgePos||Position.Left
    }
   
    connector?.fixedFromToPositions? null: edgePointData = getNodeConnectPoint(fromNode,toNode)
    let pathString = this.calcEdgeXYPath(edgePointData, edgeType).path
    if (!pathString) {
      return newEdgeGroup
    }
    let newPath = new Path({
      id:id + '_edge_path',
      x:0,
      y:0,
      data:pathString,
      stroke:ARROW_COLOR_Base,
      strokeWidth:ARROW_STROKE_WIDTH_Base
    })
    newEdgeGroup.path = newPath
    newEdgeGroup.pointer = this.createConnectPoint(edgePointData.pointTo,edgePointData.pointToPosition,id,edgePointerType)
    return newEdgeGroup
  }
  calcEdgeXYPath(edgePointData:IEdgePointersData,edgeType:EEdgyType):IXYEdgeData{
    
    switch (edgeType) {
      case  EEdgyType.SmoothStep:
       return getSmoothStepPath({
          sourceX: edgePointData.pointFrom.x, 
          sourceY: edgePointData.pointFrom.y,
          sourcePosition: edgePointData.pointFromPosition,
          targetX: edgePointData.pointTo.x,
          targetY: edgePointData.pointTo.y,
          targetPosition: edgePointData.pointToPosition,
          borderRadius:20
        })
      case  EEdgyType.Step:
       return getSmoothStepPath({
          sourceX: edgePointData.pointFrom.x, 
          sourceY: edgePointData.pointFrom.y,
          sourcePosition: edgePointData.pointFromPosition,
          targetX: edgePointData.pointTo.x,
          targetY: edgePointData.pointTo.y,
          targetPosition: edgePointData.pointToPosition,
          borderRadius:1
        })
      case  EEdgyType.Straight:
       return getStraightPath({
          sourceX: edgePointData.pointFrom.x, 
          sourceY: edgePointData.pointFrom.y,
          targetX: edgePointData.pointTo.x,
          targetY: edgePointData.pointTo.y,
        })
      default:
       return getBezierPath({
          sourceX: edgePointData.pointFrom.x, 
          sourceY: edgePointData.pointFrom.y,
          sourcePosition: edgePointData.pointFromPosition,
          targetX: edgePointData.pointTo.x,
          targetY: edgePointData.pointTo.y,
          targetPosition: edgePointData.pointToPosition,
        })
    }
  }
  createConnectPoint(point:Vector2d,pointPosition:Position, connectorId:string, pointerType?:EdgePointerType):Circle|Rect|Arrow {
    let sighnedPosition = pointPosition === Position.Right? 1 : -1 
    switch (pointerType) {
      case EdgePointerType.Circle:
        return new Konva.Circle({
          id:connectorId + '_edge_pointer',
          x: point.x + ARROW_POINTER_RADIUS * sighnedPosition,
          y:point.y ,
          radius:ARROW_POINTER_RADIUS,
          stroke:ARROW_COLOR_Base,
          fill:ARROW_COLOR_Base,
          strokeWidth:ARROW_STROKE_WIDTH_Base
        })
      case EdgePointerType.Arrow:
        let xShift = 0
        let yShift = 0
        switch (pointPosition) {
          case Position.Left:
            xShift = -30
          break;
          case Position.Right:
            xShift = 30
          break;
          case Position.Top:
            yShift = -30
          break;
          case Position.Bottom:
            xShift = 30
          break;
        }
        return new Konva.Arrow({
          id:connectorId + '_edge_pointer',
          name:'Arrow',
          points:[point.x + xShift, point.y + yShift , point.x ,point.y],
          //stroke:ARROW_COLOR_Base,
          fill:ARROW_COLOR_Base,
          pointerWidth:CONTRACT_POINTER_HEIGHT,
          pointerLength:CONTRACT_POINTER_WIDTH,
          strokeWidth:1,
        });
      default:
        return new Konva.Rect({
          id:connectorId + '_edge_pointer',
          x: point.x + sighnedPosition * ARROW_POINTER_RADIUS * (sighnedPosition ===1 ? 0.2: 3.5) ,
          y:point.y -   ARROW_POINTER_RADIUS,
          width:ARROW_POINTER_RADIUS*3.5,
          height:ARROW_POINTER_RADIUS*2,
          stroke:ARROW_COLOR_Base,
          fill:ARROW_COLOR_Base,
          strokeWidth:ARROW_STROKE_WIDTH_Base,
          cornerRadius:1,
          draggable:true
        })
    }
  }

}